import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import * as moment from "jalali-moment";
import { EditableGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/editable-grid/editable-grid.component";
import { ReportCopyComponent } from "projects/sepidz-web-framework-data-grid/src/lib/report-selector/report-copy.component";
import { ReportSelectorComponent } from "projects/sepidz-web-framework-data-grid/src/lib/report-selector/report-selector.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { InvStatusKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { debounceTime, takeUntil } from "rxjs/operators";
import { InvVoucherDetail } from "../../models/inv-voucher-detail.model";
import { InvVoucherHeader } from "../../models/inv-voucher-header.model";
import { TakingOfInventoryDetail } from "../../models/taking-of-inventory-detail.model";
import { TakingOfInventoryHeader } from "../../models/Taking-Of-Inventory-Header.model";

@Component({
  selector: "ngx-taking-of-inventory-form",
  templateUrl: "./taking-of-inventory-form.component.html",
  styleUrls: ["./taking-of-inventory-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class TakingOfInventoryFormComponent extends BaseFormComponent<TakingOfInventoryHeader> {
  erroremessage: string;
  DefaultValues: Dictionary = [];
  currentReport: string = "print";
  TakingOfInventoryDetailList: form_control[];
  @ViewChild("editablegrid") public editablegrid: EditableGridComponent;
  get currentFiscalYear() {
    return this.accountService.authService.currentFiscalYear;
  }
  dataiIsLOaded: boolean = false;
  _isClosing: boolean = false;
  constructor(
    private lookupService: LookupService,
    private datatransfer: Datatransfer,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    __id: FormContainerModel,
    _tabsservice: TabularService
  ) {
    super(selectorService, cd);
    this.currentrow = this.datatransfer?.currentrow;
    this.apiName = this.datatransfer?.apiName;
    this.label = this.datatransfer?.label;
    this.areaName = this.datatransfer?.areaName;
    this._id = __id;
    this.tabsservice = _tabsservice;
  }
  async ngOnInit() {
    this.reportName = "TakingOfInventory";
    this.apiName = "TakingOfInventoryHeader";
    this.label = "انبارگردانی";

    this.ReportSelectorForm = ReportSelectorComponent;
    this.ReportCopyForm = ReportCopyComponent;
    this.pathPreFix = "INV";
    super.ngOnInit();
    this.loadReports();
  }
  setMaxCode() {
    this.httpCommonService
      .getMaxCode(this.apiName)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (!this.model) this.model = new TakingOfInventoryHeader();
          if (data) {
            this.model["Number"] = data as number;
            this.setValue("Number", data);
          }
          this.setdefault();
        },
        (error) => this.getFailedHelper(error)
      );
  }
  onRowSelected($event) {}
  onChange($event) {
    if ($event && $event.apiName && $event.apiName.includes("Warehouse")) {
      this.model.WarehouseTitle = $event.data.Title;
      this.model.WarehouseCode = $event.data.Code;
    }
  }
  setColumnAttribute(): void {
    super.setColumnAttribute();
    this.TakingOfInventoryDetailList = this.getDetailControlModels("TakingOfInventoryDetailList");
    this.columns.forEach((x) => {
      if (!x.name.includes("DetailLedger")) x.disabled = this.model?.TakingOfInventoryDetailList?.length > 0;
    });
    this.columns.forEach((x) => (x.isFloat = null));
    this.columns.forEach((x) => (x.userClass = null));
    this.cd.markForCheck();
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.TakingOfInventoryDetailList = undefined;
  }
  setdefault() {
    this.DefaultValues["TakingOfInventoryHeaderId"] = 0;
    if (!this.model.BranchId) this.model.BranchId = this.accountService.authService.currentBranchId;
    if (!this.model.TakingOfInventoryDetailList) this.model.TakingOfInventoryDetailList = [];
    if (!this.model.FiscalYearId) {
      if (this.currentFiscalYear) this.model.FiscalYearId = this.currentFiscalYear.Id;
      else
        this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
          if (x) {
            this.model.FiscalYearId = x.Id;
            this.setValue("FiscalYearId", x.Id);
          }
        });
    }
    if (!this.model.StatusKindId) {
      this.lookupService
        .getLookupbyCode("INV", "StatusKind", InvStatusKind.Registered)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.StatusKindId = x.Id;
          this.model.StatusKindCode = x.Code;
          this.model.StatusKindTitle = x.Title;
          this.setValue("StatusKindId", x.Id);
        });
    }
    if (!this.model.InventoryBalancingDate) {
      this.model.InventoryBalancingDate = new Date();
    }
    this.dataiIsLOaded = this.model.TakingOfInventoryDetailList && this.model.TakingOfInventoryDetailList.length > 0;
  }

  preparation(inCreament: boolean) {
    if (
      this.model.InventoryReceiptId ||
      this.model.InventoryDeliveryId ||
      (!this.model.InventoryDeliveryVoucherKindId && !this.model.InventoryReceiptVoucherKindId)
    )
      return;

    var refVoucher: InvVoucherHeader = <InvVoucherHeader>{};

    refVoucher.VoucherNo = 0;
    refVoucher.FiscalYearId = this.model.FiscalYearId;
    refVoucher.TotalPrice = this.model.TakingOfInventoryDetailList.filter(
      (x) => (inCreament && x.FinalMainRemainAmount > 0) || (!inCreament && x.FinalMainRemainAmount < 0)
    )?.getSumWithKey("TotalPrice");
    if (refVoucher.TotalPrice < 0) refVoucher.TotalPrice = refVoucher.TotalPrice * -1;
    refVoucher.VoucherKindId = inCreament ? this.model.InventoryReceiptVoucherKindId : this.model.InventoryDeliveryVoucherKindId;
    refVoucher.VoucherKindCode = inCreament ? this.model.InventoryReceiptVoucherKindCode : this.model.InventoryDeliveryVoucherKindCode;
    refVoucher.VoucherKindTitle = inCreament ? this.model.InventoryReceiptVoucherKindTitle : this.model.InventoryDeliveryVoucherKindTitle;
    refVoucher.InvVoucherDetailList = [];
    refVoucher.Comment = this.model.Comment;
    refVoucher.VoucherDate = this.model.InventoryBalancingDate;
    refVoucher.StatusKindId = this.model.StatusKindId;
    refVoucher.StatusKindCode = this.model.StatusKindCode;
    refVoucher.StatusKindTitle = this.model.StatusKindTitle;
    refVoucher.WarehouseId = this.model.WarehouseId;
    refVoucher.WarehouseCode = this.model.WarehouseCode;
    refVoucher.WarehouseTitle = this.model.WarehouseTitle;
    refVoucher.DetailLedgerId = this.model.DetailLedgerId;
    refVoucher.DetailLedgerCode = this.model.DetailLedgerCode;
    refVoucher.DetailLedgerTitle = this.model.DetailLedgerTitle;
    this.model.TakingOfInventoryDetailList.filter(
      (x) =>
        (inCreament && x.FinalMainRemainAmount && x.FinalMainRemainAmount > 0) ||
        (!inCreament && x.FinalMainRemainAmount && x.FinalMainRemainAmount < 0)
    ).forEach((x) => {
      var vd: InvVoucherDetail = <InvVoucherDetail>{};
      vd.GoodsId = x.GoodsId;
      vd.GoodsCode = x.GoodsCode;
      vd.GoodsTitle = x.GoodsTitle;
      vd.GoodsUnitId = x.DefaultUnitId ? x.DefaultUnitId : 0;
      vd.GoodsUnitCode = x.DefaultUnitCode ? x.DefaultUnitCode : 0;
      vd.GoodsUnitTitle = x.DefaultUnitTitle;
      vd.Amount = x.FinalRemainAmount > 0 ? x.FinalRemainAmount : x.FinalRemainAmount * -1;
      vd.MainAmount = x.FinalMainRemainAmount > 0 ? x.FinalMainRemainAmount : x.FinalMainRemainAmount * -1;
      vd.GoodsUnitRatio = x.DefaultUnitRatio ? x.DefaultUnitRatio : 1;
      vd.Comment = "انبار گردانی";
      vd.PriceUnitId = vd.GoodsUnitId;
      vd.UnitPrice = inCreament === true && x.UnitPrice ? x.UnitPrice : 0;
      refVoucher.InvVoucherDetailList.push(vd);
    });
    if (refVoucher.InvVoucherDetailList != null && refVoucher.InvVoucherDetailList.length > 0) {
      this.model.InventoryReceiptId = refVoucher.Id;
      this.model.InventoryReceiptNo = refVoucher.VoucherNo;
    }
    return refVoucher;
  }
  notPrintable() {
    return this.model && this.model.TakingOfInventoryDetailList && this.model.TakingOfInventoryDetailList.length > 0;
  }
  notCreatable() {
    return (
      !this.model ||
      !this.model.TakingOfInventoryDetailList ||
      this.model.TakingOfInventoryDetailList.length <= 0 ||
      (this.model.InventoryReceiptId !== undefined && this.model.InventoryReceiptId !== null) ||
      (this.model.InventoryDeliveryId !== undefined && this.model.InventoryDeliveryId !== null)
    );
  }
  notDeleteable() {
    return !this.model.InventoryReceiptId || !this.model.InventoryDeliveryId;
  }
  submitButtonDisabled() {
    return (
      (this.model.InventoryReceiptId !== undefined && this.model.InventoryReceiptId !== null) ||
      (this.model.InventoryDeliveryId !== undefined && this.model.InventoryDeliveryId !== null)
    );
  }
  createInvVoucher() {
    if (
      this.model.InventoryReceiptId ||
      this.model.InventoryDeliveryId ||
      (!this.model.InventoryDeliveryVoucherKindId && !this.model.InventoryReceiptVoucherKindId)
    )
      return;

    let inCreament = this.preparation(true);
    let deCreament = this.preparation(false);
    let _model = {
      TakingOfInventoryHeader: this.getDataFromFormGroup(),
      InCreamentVoucher: inCreament,
      DeCreamentVoucher: deCreament,
    };
    this.httpCommonService
      .updateItem(`TakingOfInventoryHeader/CreateInventoryVoucher`, _model)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          this.ngOnInit();
        },
        (error) => this.getFailedHelper(error)
      );
  }
  deleteInvVoucher() {
    if (!this.model.InventoryReceiptId && !this.model.InventoryDeliveryId) return;
    this.isDetailValid();
    if (!this.model?.HasPricing) {
      this.httpCommonService
        .updateItem(`TakingOfInventoryHeader/DeleteInventoryVoucher`, this.getDataFromFormGroup())
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            this.ngOnInit();
          },
          (error) => this.getFailedHelper(error)
        );
    }
  }
  isDetailValid() {
    if (this.model?.HasPricing) {
      this.erroremessage = "بعلت قیمت گذاری اسناد اضافات و کسورات،سند قابل حذف نمی باشد";
    }
  }
  hasFirstVoucher(): boolean {
    return false;
  }

  onValueChanges(form: UntypedFormGroup) {
    let Orignal = this.model?.TakingOfInventoryDetailList?.find((x) => x.TagNumber == form.controls["TagNumber"].value);

    form.controls["MainQuantity"].valueChanges.pipe(debounceTime(300)).subscribe(() => {
      if (form.controls["MainQuantity"].value !== Orignal.MainQuantity) {
        if (
          form.controls["MainQuantity"].value >= 0 &&
          form.controls["DefaultUnitRatio"].value &&
          form.controls["Quantity"].value !== form.controls["MainQuantity"].value / form.controls["DefaultUnitRatio"].value
        ) {
          form.controls["Quantity"].patchValue(form.controls["MainQuantity"].value / form.controls["DefaultUnitRatio"].value, { emitEvent: false });
        }
      }
    });

    form.controls["Quantity"].valueChanges.pipe(debounceTime(300)).subscribe(() => {
      if (form.controls["Quantity"].value !== Orignal.Quantity) {
        if (
          form.controls["Quantity"].value >= 0 &&
          form.controls["DefaultUnitRatio"].value &&
          form.controls["MainQuantity"].value !== form.controls["Quantity"].value * form.controls["DefaultUnitRatio"].value
        ) {
          form.controls["MainQuantity"].patchValue(form.controls["Quantity"].value * form.controls["DefaultUnitRatio"].value, { emitEvent: false });
        }
      }
    });

    form.controls["RemainAmount"].valueChanges.pipe(debounceTime(300)).subscribe(() => {
      if (
        form.controls["RemainAmount"].value &&
        form.controls["Quantity"].value &&
        form.controls["FinalRemainAmount"].value !== form.controls["Quantity"].value - form.controls["RemainAmount"].value
      ) {
        form.controls["FinalRemainAmount"].patchValue(form.controls["Quantity"].value - form.controls["RemainAmount"].value, { emitEvent: false });
      }
    });

    form.controls["MainRemainAmount"].valueChanges.pipe(debounceTime(300)).subscribe(() => {
      if (
        form.controls["MainQuantity"].value &&
        form.controls["MainRemainAmount"].value &&
        form.controls["FinalMainRemainAmount"].value !== form.controls["MainQuantity"].value - form.controls["MainRemainAmount"].value
      ) {
        form.controls["FinalMainRemainAmount"].patchValue(form.controls["MainQuantity"].value - form.controls["MainRemainAmount"].value, {
          emitEvent: false,
        });
      }
    });

    this.erroremessage = undefined;
  }
  ValueChanges(entity: TakingOfInventoryDetail) {
    if (entity && entity.DefaultUnitRatio !== entity.MainQuantity / entity.DefaultUnitRatio)
      entity.Quantity = entity.MainQuantity / entity.DefaultUnitRatio;

    if (entity.Quantity && entity.DefaultUnitRatio && entity.MainQuantity !== entity.Quantity * entity.DefaultUnitRatio)
      entity.MainQuantity = entity.Quantity * entity.DefaultUnitRatio;

    if (entity.RemainAmount && entity.Quantity && entity.FinalRemainAmount !== entity.Quantity - entity.RemainAmount)
      entity.FinalRemainAmount = entity.Quantity - entity.RemainAmount;
    if (entity.MainQuantity && entity.MainRemainAmount && entity.FinalMainRemainAmount !== entity.MainQuantity - entity.MainRemainAmount)
      entity.FinalMainRemainAmount = entity.MainQuantity - entity.MainRemainAmount;
  }
  isValid() {
    let flag: boolean = true;
    if (!this.model.TakingOfInventoryDetailList || this.model.TakingOfInventoryDetailList.length <= 0) {
      this.erroremessage = "هیچ آرتیکلی وجود ندارد";
      flag = false;
    }

    this.model.TakingOfInventoryDetailList.forEach((x) => {
      if (!x.TakingOfInventoryHeaderId) x.TakingOfInventoryHeaderId = 0;
      this.ValueChanges(x);
    });
    if (this.model.TakingOfInventoryDetailList.some((x) => x.MainQuantity === undefined)) {
      this.erroremessage = "تعدادی از کالاها شمارش نشده است.";
      flag = false;
    }
    return flag;
  }

  printTag() {
    if (this.model.TakingOfInventoryDetailList && this.model.TakingOfInventoryDetailList.length > 0) return;
    this.erroremessage = undefined;
    if (this.hasFirstVoucher()) {
      this.erroremessage = "به دلیل وجود رسید ابتدای دوره ایجاد تگ امکان پذیر نیست.";
      return;
    }
    this.model.WarehouseId = this.formGroup.controls["WarehouseId"].value;
    this.model.InventoryBalancingDate = this.formGroup.controls["InventoryBalancingDate"].value;

    if (!this.model.WarehouseId) {
      this.erroremessage = "انبار انتخاب نشده است.";
      return;
    }
    if (!this.model.InventoryBalancingDate) {
      this.erroremessage = "تاریخ انبار گردانی انتخاب نشده است.";
      return;
    }
    this.model.TakingOfInventoryDetailList = [];
    this.httpCommonService
      .create(`Goods/GetInventoryBalancingByWarehouse`, {
        WarehouseId: this.formGroup?.get("WarehouseId")?.value,
        FiscalYearId: this.formGroup?.get("FiscalYearId")?.value,
        CurrentDate: this.formGroup?.get("InventoryBalancingDate")?.value,
      })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          if (x) {
            let Tagnumber: number = 0;
            (x as any[]).forEach((item) => {
              Tagnumber++;
              var row = <TakingOfInventoryDetail>{};
              row.GoodsId = item.Id;
              row.GoodsCode = item.Code;
              row.GoodsTitle = item.Title;
              row.MainRemainAmount = item.RemainAmount;
              row.RemainAmount = item.RemainAmount / (!item.DefaultUnitRatio || item.DefaultUnitRatio === 0 ? 1 : item.DefaultUnitRatio);
              row.TagNumber = Tagnumber;
              if (!row.RemainAmount) row.RemainAmount = 0;
              row.UnitId = item.UnitId;
              row.UnitCode = item.UnitCode;
              row.UnitTitle = item.UnitTitle;
              row.DefaultUnitId = item.DefaultUnitId;
              row.DefaultUnitCode = item.DefaultUnitCode;
              row.DefaultUnitTitle = item.DefaultUnitTitle;
              row.UnitPrice = item.UnitPrice * item.DefaultUnitRatio;
              if (!row.UnitPrice) row.UnitPrice = 0;
              row.DefaultUnitRatio = !item.DefaultUnitRatio || item.DefaultUnitRatio === 0 ? 1 : item.DefaultUnitRatio;
              this.model.TakingOfInventoryDetailList.push(row);
            });
            if (this.editablegrid) {
              this.editablegrid.dataList = this.model.TakingOfInventoryDetailList;
              this.editablegrid.refreshform();
            }
            this.cd.markForCheck();
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }
  setButtonEnable() {}
  private SaveTakingOfInventoryDetail(json: string) {
    let entityList: TakingOfInventoryDetail[] = JSON.parse(json);
    if (entityList == null || entityList.length <= 0) {
      this.sts.showDialog(`خواندن اطلاعات با مشکل مواجه شد یک بار دیگر سعی کنید.`, "پیغام خطا");
      return;
    }
    this.model.TakingOfInventoryDetailList.forEach((item) => {
      if (item) {
        var res = entityList.find((x) => x.GoodsId === item.GoodsId && x.Quantity);
        if (res != null) {
          item.Quantity = res.Quantity;
          item.MainQuantity = item.Quantity * item.DefaultUnitRatio;
        }
      }
    });
    if (this.editablegrid) {
      this.editablegrid.dataList = this.model.TakingOfInventoryDetailList;
      this.editablegrid.refreshform();
      this.cd.markForCheck();
    }
  }
  btnExport() {
    const date = moment(this.model.InventoryBalancingDate) || moment();
    date.jYear();
    let jsondata = JSON.stringify(this.model.TakingOfInventoryDetailList);
    let filename = `TakingOfInventory${this.model.WarehouseCode}${date.jYear()}${date.jMonth()}${date.jDay()}.json`;
    var a = document.createElement("a");
    a.setAttribute("href", "data:text/plain;charset=utf-u," + encodeURIComponent(jsondata));
    a.setAttribute("download", filename);
    a.click();
  }
  openFile(event) {
    this.sts.showToast("info", "", "در حال ذخیره تغییرات...");
    let input = event.target;
    var text;
    for (var index = 0; index < input.files.length; index++) {
      let reader = new FileReader();
      reader.onload = () => {
        text = reader.result;
        if (text) {
          {
            this.SaveTakingOfInventoryDetail(text);
          }
        }
      };
      reader.readAsText(input.files[index]);
    }
  }
  isCloseable() {
    this.selectorService.submitted$.next(false);
    this.formGroup?.markAsUntouched();
    this.currentrow = this.model;
    return false;
  }
}
